var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgServiceTimes = function SvgServiceTimes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22.041,
    height: 22.041,
    fill: "#171D38",
    rx: 11.02
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#serviceTimes_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m11.586 5.186-5.813 7.017 5.25-.015-.57 4.668 5.813-7.017-5.25.016z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "serviceTimes_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    x: 4,
    y: 4.041,
    fill: "#fff",
    rx: 7,
    transform: "rotate(-.166 4 4.041)"
  })))));
};
export default SvgServiceTimes;